export default function generateCSSRule(selector, cssDeclaration) {
  return selector + "{" + cssDeclaration + "}";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateCSSRule.js
// module id = 723
// module chunks = 0